import { render } from "./ScrollSpyBox.vue?vue&type=template&id=09c8a05e"
import script from "./ScrollSpyBox.vue?vue&type=script&lang=js"
export * from "./ScrollSpyBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/pro/Navigation/ScrollSpyBox.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "09c8a05e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('09c8a05e', __exports__)) {
    api.reload('09c8a05e', __exports__)
  }
  
  module.hot.accept("./ScrollSpyBox.vue?vue&type=template&id=09c8a05e", () => {
    api.rerender('09c8a05e', render)
  })

}


export default __exports__